module.exports = __webpack_public_path__ + "img/PC_04.5fe63d10.jpg";